import { ApiError } from "../api/client";

export function ErrorBox({ error }: { error: unknown }) {
  if (!error) return null;
  const e = error as Error;
  const details = error instanceof ApiError ? error.details : [];
  return (
    <div role="alert" className="error-box" data-testid="error">
      <strong>{error instanceof ApiError ? `${error.status}: ` : ""}{e.message}</strong>
      {details.length > 0 && <ul>{details.map((d) => <li key={d}>{d}</li>)}</ul>}
    </div>
  );
}
